<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Servidores {{ nomeCidade }}
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie todos os clientes e respectivos municípios.
          Utilize a busca e os filtros para encontrar e atualizar informações de forma eficiente.
        </p>
      </div>
    </div>

    <form #servForm="ngForm" (ngSubmit)="applyFilters()" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-size: 14px">Nome</label>
              <input
                type="text"
                id="nome"
                class="form-control"
                [(ngModel)]="filterName"
                name="nome"
                placeholder="Digite um nome próprio"
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="cpf" style="font-size: 14px">CPF</label>
              <input
                type="text"
                id="cpf"
                class="form-control"
                [(ngModel)]="filterCpf"
                name="cpf"
                placeholder="Digite um CPF"
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="matricula" style="font-size: 14px">Matrícula</label>
              <input
                type="text"
                id="matricula"
                class="form-control"
                [(ngModel)]="filterMatricula"
                name="matricula"
                placeholder="Digite uma matrícula"
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="filtros_diversos" style="font-size: 14px"
                >Filtros diversos</label
              >
              <ng-select
                [items]="filtrosDiversosOpcoes"
                name="filtros_diversos"
                bindLabel="name"
                bindValue="id"
                placeholder="Selecione"
                id="filtros_diversos"
                [(ngModel)]="filterDiverso"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="status" style="font-size: 14px">Status</label>
              <ng-select
                [items]="statusServidor"
                name="status"
                bindLabel="name"
                bindValue="id"
                placeholder="Selecione um Status"
                id="status"
                [(ngModel)]="filterStatus"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <label for="data_cadastro" style="font-size: 14px"
              >Data de cadastro</label
            >
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="date"
                  id="data_cadastro"
                  class="form-control"
                  [(ngModel)]="filterCreatedAt.start"
                  name="data_cadastro"
                  placeholder="dd-mm-yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="date"
                  id="data_cadastro_fim"
                  class="form-control"
                  [(ngModel)]="filterCreatedAt.end"
                  name="data_cadastro_fim"
                  placeholder="dd-mm-yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="data_nascimento" style="font-size: 14px"
              >Data de nascimento</label
            >
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="date"
                  id="data_nascimento"
                  class="form-control"
                  [(ngModel)]="filterBirthDate.start"
                  name="data_nascimento"
                  placeholder="dd-mm-yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="date"
                  id="data_nascimento_fim"
                  class="form-control"
                  [(ngModel)]="filterBirthDate.end"
                  name="data_nascimento_fim"
                  placeholder="dd-mm-yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="form-row d-flex justify-content-between align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="goBack()"
        >
          <i class="fa fa-arrow-left mr-2"></i>Voltar
        </button>
      </div>
      <div class="col-auto d-flex gap-2">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
        <button
          type="submit"
          class="btn btn-outline-primary mb-2 mb-md-0"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>
    </form>
  </div>
</div>

<!-- LISTAGEM SERVIDORES -->
<div class="card servidores-lista" style="border-radius: 10px">
  <table class="table text-center" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('cpf')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            CPF
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('cpf')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('cpf')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('cpf')"
                class="fa"
                [ngClass]="getSortIcon('cpf')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('matricula')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Matrícula(s)
            <div class="sort-icons ml-1">
              <i
                *ngIf="!isColumnSorted('matricula')"
                class="fa fa-caret-up"
              ></i>
              <i
                *ngIf="!isColumnSorted('matricula')"
                class="fa fa-caret-down"
              ></i>
              <i
                *ngIf="isColumnSorted('matricula')"
                class="fa"
                [ngClass]="getSortIcon('matricula')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('status')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Status
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('status')"
                class="fa"
                [ngClass]="getSortIcon('status')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('conferencia')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Conferência
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('conferencia')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('conferencia')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('conferencia')"
                class="fa"
                [ngClass]="getSortIcon('conferencia')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center">Ações</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let servidor of servidoresFiltered; let index = index">
        <tr
          class="servidor-grupo"
          [class.servidor-grupo-alternado]="index % 2 !== 0"
          [class.servidor-grupo-aberto]="isServidorExpanded(servidor)"
          role="button"
          tabindex="0"
          (click)="toggleServidor(servidor)"
          (keydown.enter)="toggleServidor(servidor)"
          (keydown.space)="$event.preventDefault(); toggleServidor(servidor)"
          [attr.aria-expanded]="isServidorExpanded(servidor)"
        >
          <td class="pl-3 pr-3">
            <div class="d-flex align-items-center servidor-identificacao">
              <span class="servidor-toggle" aria-hidden="true">
                <i [ngClass]="isServidorExpanded(servidor) ? 'ft-chevron-down' : 'ft-chevron-right'"></i>
              </span>
              <img
                width="40"
                height="40"
                alt="datatable-avatar"
                class="square rounded-circle"
                [ngClass]="{ 'cursor-pointer': servidor && servidor.imagem }"
                (click)="$event.stopPropagation(); servidor && servidor.imagem ? viewMidia(servidor.imagem, contentImg) : null"
                [src]="servidor && servidor.imagem ? servidor.imagem : 'assets/img/portrait/small/no-avatar.svg'"
              />
              <div>{{ servidor.nome }}</div>
            </div>
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            {{ servidor.cpf | mask : "000.000.000-00" }}
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            {{ servidor.quantidade_matriculas || getMatriculasServidor(servidor).length }}
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            <span
              *ngFor="let status of getStatusServidor(servidor)"
              class="status-servidor"
              [ngClass]="getStatusClass(status)"
            >
              {{ classificaStatus(status) }}
            </span>
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            <span
              class="status-servidor conferencia-status"
              [ngClass]="getSituacaoConferenciaClass(servidor)"
            >
              {{ getSituacaoConferencia(servidor) }}
            </span>
          </td>
          <td class="align-middle servidor-acoes" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div class="d-flex justify-content-end align-items-center">
              <button
                type="button"
                class="btn btn-outline-primary btn-sm acao-icone"
                routerLink="/page/servidorv2"
                [queryParams]="{ id: servidor.id, idCidade: idCidade, id_matricula: getMatriculaInicial(servidor)?.id, modo: 'visualizacao' }"
                title="Visualizar"
                aria-label="Visualizar servidor em modo somente leitura"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm acao-icone"
                (click)="acionarConferencia(modalIniciarConferencia, modalServidorEmConferencia, servidor)"
                [disabled]="!podeAcionarConferencia(servidor)"
                [title]="getTituloAcaoConferencia(servidor)"
                [attr.aria-label]="getTituloAcaoConferencia(servidor)"
              >
                <i class="fa fa-check-square-o" aria-hidden="true"></i>
              </button>
              <div class="dropdown btn-group ml-1" ngbDropdown placement="bottom-right">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm dropdown-toggle action-btn"
                  ngbDropdownToggle
                  title="Mais Ações"
                >
                  Mais Ações
                </button>
                <div
                  ngbDropdownMenu
                  class="dropdown-menu dropdown-brprev"
                  role="menu"
                >
                <a
                  class="dropdown-item dropdown-brprev"
                  (click)="getRelatorioServidor(relatorio, servidor)"
                  style="cursor: pointer;"
                >
                  <i class="fa fa-file-text-o"></i> Relatório
                </a>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr class="servidor-matricula" *ngFor="let matricula of getMatriculasServidor(servidor)" [hidden]="!isServidorExpanded(servidor)">
          <td class="text-left align-middle"><span class="matricula-label">Matrícula</span></td>
          <td></td>
          <td class="text-center align-middle">{{ matricula.matricula || '-' }}</td>
          <td class="text-center align-middle">
            <span class="status-servidor" [ngClass]="getStatusClass(matricula.status)">
              {{ classificaStatus(matricula.status) }}
            </span>
          </td>
          <td class="text-center align-middle">
            <span class="status-servidor conferencia-status" [ngClass]="getSituacaoConferenciaClass({ situacao_nova: matricula.situacao })">
              {{ getSituacaoConferencia({ situacao_nova: matricula.situacao }) }}
            </span>
          </td>
          <td class="text-right align-middle">
            <a
              routerLink="/page/servidorv2"
              [queryParams]="{ id: servidor.id, idCidade: idCidade, id_matricula: matricula.id, modo: 'visualizacao' }"
            >Ver detalhes</a>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <div class="form-row" *ngIf="total > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
         Exibindo {{total > 0 ? (page-1) * pageSize + 1 : 0}} a {{getMaxItemsDisplayed()}} de {{total}} itens
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
          class="ml-auto pagination-square"
          style="margin-top: 10px; margin-right: 10px"
          *ngIf="total > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true"
          size="sm"
          [collectionSize]="total"
          (pageChange)="onPageChange()"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="total == 0 && !servidoresFiltered.length">
  <div class="col">
    <div class="card-content">
      <div class="card-body">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="media">
              <div class="media-body">
                <h5 class="mt-0">Nenhum servidor encontrado.</h5>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<ng-template #contentImg>
  <IMG style="width: 100%; height: 100%" [src]="urlToShow" />
</ng-template>

<!-- Modal de Iniciar Conferência -->
<ng-template #modalIniciarConferencia let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center" style="border-bottom: 1px solid #dee2e6; padding: 1rem 1.5rem">
    <h4 class="modal-title mb-0" style="color: #333; font-weight: 500; font-size: 24px">
      {{ servidorSelecionado?.situacao_nova === 'inconsistente' ? 'Continuar Conferência' : 'Iniciar Conferência' }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body" style="padding: 2rem">
    <p *ngIf="servidorSelecionado?.situacao_nova !== 'inconsistente'" style="font-size: 16px; line-height: 1.6; color: #333; margin-bottom: 0">
      Deseja iniciar a conferência deste servidor? Todas as
      {{ servidorSelecionado?.quantidade_matriculas || getMatriculasServidor(servidorSelecionado).length }}
      matrícula(s) serão iniciadas e atribuídas a você.
    </p>
    <p *ngIf="servidorSelecionado?.situacao_nova === 'inconsistente'" style="font-size: 16px; line-height: 1.6; color: #333; margin-bottom: 0">
      Este servidor possui matrícula(s) já conferida(s). Deseja continuar a conferência das
      {{ getQuantidadeMatriculasPendentes(servidorSelecionado) }} matrícula(s) pendente(s)?
      As conferências já concluídas serão preservadas.
    </p>
  </div>
  
  <div class="modal-footer" style="border-top: 1px solid #dee2e6; padding: 1rem 1.5rem">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Voltar')"
      style="margin-right: 10px;"
    >
      Voltar
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="iniciarConferencia(modal)"
      [disabled]="isIniciandoConferencia"
    >
      <span *ngIf="!isIniciandoConferencia">
        {{ servidorSelecionado?.situacao_nova === 'inconsistente' ? 'Continuar Conferência' : 'Iniciar Conferência' }}
      </span>
      <span *ngIf="isIniciandoConferencia">
        <i class="fa fa-spinner fa-spin"></i> Processando...
      </span>
    </button>
  </div>
</ng-template>

<!-- Modal do servidor que já está em conferência -->
<ng-template #modalServidorEmConferencia let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center" style="border-bottom: 1px solid #dee2e6; padding: 1rem 1.5rem">
    <h4 class="modal-title mb-0" style="color: #333; font-weight: 500; font-size: 24px">
      Servidor em Conferência
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body" style="padding: 2rem">
    <p style="font-size: 16px; line-height: 1.6; color: #333; margin-bottom: 1.5rem">
      Este servidor já está em processo de conferência. Se você estava conferindo o servidor,
      pode retomar a conferência ou selecionar uma situação final de conferência para concluir o processo.
    </p>
    <div class="form-group">
      <label for="situacaoFinalizar" style="font-weight: 600; margin-bottom: 0.5rem;">Situação</label>
      <select
        class="form-control"
        id="situacaoFinalizar"
        [(ngModel)]="situacaoFinalizar"
        name="situacaoFinalizar"
      >
        <option value="">Selecione uma opção</option>
        <option
          *ngFor="let opcao of opcoesFinalizarConferencia"
          [value]="opcao.value"
        >
          {{ opcao.label }}
        </option>
      </select>
    </div>
  </div>
  
  <div class="modal-footer" style="border-top: 1px solid #dee2e6; padding: 1rem 1.5rem">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Voltar')"
      style="margin-right: 10px;"
    >
      Voltar
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="submeterConferenciaEmAndamento(modal)"
      [disabled]="isFinalizandoConferencia"
    >
      <span *ngIf="!isFinalizandoConferencia">
        {{ situacaoFinalizar ? 'Finalizar Conferência' : 'Retomar Conferência' }}
      </span>
      <span *ngIf="isFinalizandoConferencia">
        <i class="fa fa-spinner fa-spin"></i> Finalizando...
      </span>
    </button>
  </div>
</ng-template>

<ng-template #relatorio let-modal>
  <div
    class="modal-header d-flex justify-content-between align-items-center"
    style="border-bottom: 1px solid #dee2e6; padding: 1rem 1.5rem"
  >
    <h4
      class="modal-title mb-0"
      style="color: #333; font-weight: 500; font-size: 24px"
    >
      Relatório do Servidor
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body" style="padding: 0">
    <div
      id="print-section"
      style="
        background: white;
        padding: 2rem;
        font-family: Arial, sans-serif;
        color: #333;
      "
    >
      <!-- Cabeçalho centralizado -->
      <div style="text-align: center; margin-bottom: 2rem">
        <h1
          style="
            color: #16a085;
            font-size: 40px;
            font-weight: 500;
            margin: 0 0 0.5rem 0;
          "
        >
          Prefeitura Municipal de {{ nomeCidade }}
        </h1>
        <p
          style="
            color: #666;
            margin: 0;
            font-size: 20px;
            line-height: 1.4;
            font-family: 'Montserrat', Arial, sans-serif;
          "
          *ngIf="servidor.inicio_atendimento"
        >
          Você participou do censo previdenciário
          {{ getYear(servidor.inicio_atendimento) }} do regime próprio de
          previdência social<br />
          no município de {{ nomeCidade }}.
        </p>
      </div>

      <!-- Informações básicas em formato tabular -->
      <div style="margin-bottom: 2rem">
        <div
          style="display: flex; margin-bottom: 1rem"
          *ngIf="servidor.inicio_atendimento"
        >
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Início do Atendimento:</span
          >
          <span
            style="
              font-family: monospace;
              font-weight: 500;
              font-size: 20px;
              width: 70%;
            "
            >[{{ beautifulDate(servidor.inicio_atendimento) }}]</span
          >
        </div>
        <div
          style="display: flex; margin-bottom: 1rem"
          *ngIf="servidor.fim_atendimento"
        >
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Fim do Atendimento:</span
          >
          <span
            style="
              font-family: monospace;
              font-weight: 500;
              font-size: 20px;
              width: 70%;
            "
            >[{{ beautifulDate(servidor.fim_atendimento) }}]</span
          >
        </div>
        <div
          style="display: flex; margin-bottom: 1rem"
          *ngIf="servidor.matricula"
        >
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Matrícula:</span
          >
          <span
            style="
              font-family: monospace;
              font-weight: 500;
              font-size: 20px;
              width: 70%;
            "
            >{{ servidor.matricula }}</span
          >
        </div>
      </div>

      <!-- Linha separadora -->
      <hr
        style="
          border: none;
          height: 1px;
          background-color: #ddd;
          margin: 2rem 0;
        "
      />

      <!-- Seção de informações do servidor -->
      <div style="display: flex; align-items: flex-start; gap: 2rem">
        <!-- Informações do servidor -->
        <div style="flex: 1">
          <h2
            style="
              color: #333;
              font-size: 24px;
              font-weight: 600;
              margin: 0 0 1.5rem 0;
            "
          >
            Informações do Servidor
          </h2>

          <!-- Layout tabular simples -->
          <div style="margin-bottom: 1rem">
            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.nome"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >NOME</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.nome }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.cpf"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >CPF</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.cpf | mask : "000.000.000-00" }}</span
              >
            </div>

            <div style="display: flex; margin-bottom: 1rem" *ngIf="servidor.rg">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >IDENTIDADE</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.rg }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.data_nascimento"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DATA DE NASCIMENTO</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ beautifulDateSimple(servidor.data_nascimento) }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.status"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >STATUS</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ classificaStatus(servidor.status) }}</span
              >
            </div>
          </div>
        </div>

        <!-- Foto do servidor no canto direito superior -->
        <div style="flex-shrink: 0">
          <div
            style="
              width: 150px;
              height: 150px;
              border-radius: 50%;
              overflow: hidden;
              background: #f0f0f0;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 2px solid #ddd;
            "
          >
            <img
              *ngIf="servidor && servidor.imagem"
              [src]="servidor.imagem"
              alt="Foto do servidor"
              style="width: 100%; height: 100%; object-fit: cover"
            />
            <div
              *ngIf="!servidor || !servidor.imagem"
              style="color: #999; font-size: 12px; text-align: center"
            >
              Sem foto
            </div>
          </div>
        </div>
      </div>

      <!-- Linha separadora -->
      <hr
        style="
          border: none;
          height: 1px;
          background-color: #ddd;
          margin: 2rem 0;
        "
      />

      <!-- Seção de Dependentes -->
      <div>
        <h2
          style="
            color: #333;
            font-size: 24px;
            font-weight: 600;
            margin: 0 0 1.5rem 0;
          "
        >
          Dependentes
        </h2>

        <div
          *ngIf="dependentesToShow && dependentesToShow.length > 0"
          style="margin-bottom: 2rem"
        >
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              font-family: monospace;
              font-size: 16px;
            "
          >
            <thead>
              <tr style="border-bottom: 2px solid #ddd">
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  Nome
                </th>
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  CPF
                </th>
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  Tipo
                </th>
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  Idade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let dependente of dependentesToShow"
                style="border-bottom: 1px solid #eee"
              >
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.nome }}
                </td>
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.cpf | mask : "000.000.000-00" }}
                </td>
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.tipo_dependencia_label }}
                </td>
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.idade }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          *ngIf="!dependentesToShow || dependentesToShow.length == 0"
          style="
            text-align: center;
            padding: 2rem;
            color: #666;
            font-style: italic;
          "
        >
          Nenhum dependente cadastrado.
        </div>
      </div>
    </div>
  </div>

  <!-- Rodapé com botões -->
  <div
    class="modal-footer d-flex justify-content-between"
    style="border-top: 1px solid #dee2e6; padding: 1rem 1.5rem"
  >
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Close click')"
      style="padding: 0.5rem 1.5rem; border-radius: 4px"
    >
      Fechar
    </button>

    <button
      type="button"
      class="btn"
      printTitle="Relatório do Servidor"
      printDelay="1000"
      printSectionId="print-section"
      ngxPrint
      style="
        background: #16a085;
        border-color: #16a085;
        color: white;
        padding: 0.5rem 1.5rem;
        border-radius: 4px;
      "
    >
      Imprimir
    </button>
  </div>

  <ngx-spinner></ngx-spinner>
</ng-template>

<ngx-spinner></ngx-spinner>
